module.exports = __webpack_public_path__ + "static/media/xpress-label-b.cdd03efd.png";